import { useState } from 'react';

import cn from 'classnames';

import { AddClientForm } from '../AddClientForm';
import { AddContactForm } from '../realtyForm/AddContactForm';

// client_type values from add-client-mock.js: '0' = Lead, 1 = Buyer
const CLIENT_TYPE = { lead: '0', buyer: 1 };

const typeButtons = [
  { key: 'lead', label: 'Lead' },
  { key: 'buyer', label: 'Buyer' },
  { key: 'property', label: 'Property' },
];

export const AddContactCombined = ({ handleClose = () => {} }) => {
  const [selectedType, setSelectedType] = useState('lead');

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex justify-start">
        {typeButtons.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            onClick={() => setSelectedType(key)}
            className={cn(
              'h-10 px-3 text-sm font-medium border border-gray-200 -ml-px first:ml-0 transition-colors',
              selectedType === key
                ? 'bg-accent text-accent-foreground'
                : 'bg-transparent hover:bg-muted hover:text-muted-foreground'
            )}
          >
            {label}
          </button>
        ))}
      </div>

      {selectedType === 'property' ? (
        <AddContactForm handleClose={handleClose} />
      ) : (
        <AddClientForm
          key={selectedType}
          initialClientType={CLIENT_TYPE[selectedType]}
          hideClientType={true}
          handleClose={handleClose}
        />
      )}
    </div>
  );
};
